import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { getAllScreens } from "../service/AllEmpData";
import screenReducer from "../slices/slices";



export const store = configureStore({
  reducer: {
    screen: screenReducer,
    [getAllScreens.reducerPath]: getAllScreens.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: { warnAfter: 128 },
    }).concat(getAllScreens.middleware),
});

setupListeners(store.dispatch);
